import React from "react";

function NoDataFoundPop() {
    return (
        <tr className="text-center" style={{ color: "red" }}>
            <td colSpan={5} className="text-center mt-5" style={{ color: "red" }}>
                {/* No data Found */}
                <img alt="" src="assets/img/NoDataFound/no_data_found.png" style={{ height: "200px", width: "300px" }} />
            </td>
        </tr>
    );
}
export default NoDataFoundPop;
